import React, { Component } from "react";
import MaterialBoxFooter from "./MaterialBoxFooter";
import MaterialBoxButton from "./MaterialBoxButton";
import { getDecodedHtml } from "utils/getDecodedHtml";

class MaterialBoxDesign extends Component {
	render() {
		const { data = {} } = this.props;
		const {
			materialBoxTheme,
			assetUse,
			format,
			materialBoxTitle,
			materialBoxDescription,
			imageUrl,
			imageAlt,
			downloadUrl
		} = data;
		const { buttonType } = data.button;
		return (
			<div className={"material-box-" + materialBoxTheme}>
				<div className="material-box-table">
					<div
						className={
							"material-box-tableRow " +
							(materialBoxTheme === "lite" ? "label-5-left-almost-black" : "label-5-left-dark-teal")
						}
					>
						<div className="material-box-assetUse  "> {assetUse}</div>
						{format && assetUse ? <div className="material-box-format">&nbsp;|&nbsp;</div> : ""}
						<div className={assetUse ? "material-box-format" : "material-box-format-only"}>
							{" "}
							{format}
						</div>
					</div>
				</div>
				<h3
					className="material-box-title"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(materialBoxTitle) }}
				></h3>

				<div className="material-box-download-grid ">
					{imageUrl ? (
						<div className="material-box-thumbnail ">
							{buttonType === "download" ? (
								<a
									href={downloadUrl}
									download
									className="material-box-thumbnail-img"
									rel="noopener noreferrer"
									target="_blank"
								>
									<img src={imageUrl} alt={imageAlt} />
								</a>
							) : (
								<a href={imageUrl} className="material-box-thumbnail-img" rel="noopener noreferrer">
									<img src={imageUrl} alt={imageAlt} />
								</a>
							)}
						</div>
					) : (
						""
					)}
					<div className={"material-box-desc"}>
						{materialBoxDescription ? (
							<p dangerouslySetInnerHTML={{ __html: getDecodedHtml(materialBoxDescription) }}></p>
						) : (
							""
						)}

						<MaterialBoxButton data={data} />
						<MaterialBoxFooter data={data} />
					</div>
				</div>
			</div>
		);
	}
}

export default MaterialBoxDesign;
